import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';
import { positionedWrapperStyle } from '../shared.styles';

const { colors, fonts, fontSize, spacing, radius } = redesignTheme;

export const useSearchInputStyles = makeStyles(() => ({
  searchWrap: {
    ...positionedWrapperStyle,
  },
  searchWrapConstrained: {
    width: '100%',
    maxWidth: 400,
    marginBottom: spacing.lg,
  },
  searchInputLeft: {
    width: '100%',
    height: 40,
    padding: '0 12px 0 40px',
    boxSizing: 'border-box',
    border: `1px solid ${colors.surfaceBorder}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    color: colors.text,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    lineHeight: 'normal',
    outline: 'none',
    '&::placeholder': {
      color: colors.brownLight,
      opacity: 1,
    },
    '&:focus': {
      borderColor: colors.primaryDark,
    },
    '&::-webkit-search-cancel-button': {
      WebkitAppearance: 'none',
      appearance: 'none',
      display: 'none',
    },
    '&::-ms-clear': {
      display: 'none',
      width: 0,
      height: 0,
    },
  },
  searchInputRight: {
    width: '100%',
    height: 40,
    padding: '0 44px 0 12px',
    boxSizing: 'border-box',
    border: `1px solid ${colors.border}`,
    borderRadius: 4,
    backgroundColor: colors.white,
    color: colors.text,
    fontFamily: fonts.gothic,
    fontSize: fontSize.md,
    lineHeight: 1.6,
    outline: 'none',
    '&::placeholder': {
      color: colors.label,
      opacity: 1,
    },
    '&:focus': {
      borderColor: colors.primaryDark,
    },
    '&::-webkit-search-cancel-button': {
      WebkitAppearance: 'none',
      appearance: 'none',
      display: 'none',
    },
    '&::-ms-clear': {
      display: 'none',
      width: 0,
      height: 0,
    },
  },
  searchInputWithClear: {
    paddingRight: 40,
  },
  searchIconLeft: {
    position: 'absolute',
    left: 12,
    top: 12,
    width: 16,
    height: 16,
    color: colors.brownLight,
    pointerEvents: 'none',
  },
  searchIconRight: {
    position: 'absolute',
    right: 10,
    top: 8,
    width: 24,
    height: 24,
    color: colors.primaryDark,
    pointerEvents: 'none',
  },
  searchClearButton: {
    position: 'absolute',
    right: 8,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: colors.primary,
    lineHeight: 0,
    '&:hover': {
      color: colors.primaryDark,
    },
  },
  searchClearIcon: {
    width: 18,
    height: 18,
  },
}));
